    let calendarMainContainer = document.querySelector('.Calendar .container');
    let calendarCategories = document.querySelector('.Calendar__Categories');
    let calendarMonth = document.querySelector('.Calendar .MonthCalendar');
    let calendarViewToggleButtons = [...document.querySelectorAll('.Calendar__Switch--cal-toggle')];
    let calendarSelector = document.querySelectorAll('.Calendar__Selection');
    let calendarViewToggleSwitch = document.querySelectorAll('.Calendar__Selection--toggle-back');
    let CalendarViewContainer = document.querySelector('.Calendar__ViewContainer');
    let calendarViews = [...document.querySelectorAll('.Calendar__View')];
    let calendarGrid = document.querySelector('.Calendar__Grid');
    let calendarEventBtns = [...document.querySelectorAll('.Calendar .btn-pop')];
    let calendarPopup = document.querySelector('.Calendar__Popup');
    let calendarMonthSelector = document.querySelector('.Calendar__MonthMenu .btn');
    let calendarMonthDropdown = document.querySelector('.Calendar__MonthDropdown');
    let calendarDefaultView = document.querySelector('.Calendar')?.dataset?.defaultview;

    //popup fields
    let pCategory = document.querySelectorAll('.Calendar__Popup--category');
    let pTitle = document.querySelectorAll('.Calendar__Popup--title');
    let pDate = document.querySelectorAll('.Calendar__Popup--date');
    let pTime = document.querySelectorAll('.Calendar__Popup--time');
    let pLocation = document.querySelectorAll('.Calendar__Popup--location');
    let pDesc = document.querySelectorAll('.Calendar__Popup--description');
    let pLink = document.querySelectorAll('.Calendar__Popup--link-wrap a');
    let pMobileButton = document.querySelectorAll('.Calendar__MobilePopup .button');
    let pMobile = document.querySelector('.Calendar__MobilePopup');

    let currentSelectedEvent = 0;

    export const UpdateElements = function() {
        calendarMainContainer = document.querySelector('.Calendar .container');
        calendarCategories = document.querySelector('.Calendar__Categories');
        calendarMonth = document.querySelector('.Calendar .MonthCalendar');
        calendarViewToggleButtons = [...document.querySelectorAll('.Calendar__Switch--cal-toggle')];
        calendarSelector = document.querySelectorAll('.Calendar__Selection');
        calendarViewToggleSwitch = document.querySelectorAll('.Calendar__Selection--toggle-back');
        CalendarViewContainer = document.querySelector('.Calendar__ViewContainer');
        calendarViews = [...document.querySelectorAll('.Calendar__View')];
        calendarGrid = document.querySelector('.Calendar__Grid');
        calendarEventBtns = [...document.querySelectorAll('.Calendar .btn-pop')];
        calendarPopup = document.querySelector('.Calendar__Popup');
        calendarMonthSelector = document.querySelector('.Calendar__MonthMenu .btn');
        calendarMonthDropdown = document.querySelector('.Calendar__MonthDropdown');
    
        //popup fields
        pCategory = document.querySelectorAll('.Calendar__Popup--category');
        pTitle = document.querySelectorAll('.Calendar__Popup--title');
        pDate = document.querySelectorAll('.Calendar__Popup--date');
        pTime = document.querySelectorAll('.Calendar__Popup--time');
        pLocation = document.querySelectorAll('.Calendar__Popup--location');
        pDesc = document.querySelectorAll('.Calendar__Popup--description');
        pLink = document.querySelectorAll('.Calendar__Popup--link-wrap a'); 
        pMobileButton = document.querySelectorAll('.Calendar__MobilePopup .button');
        pMobile = document.querySelector('.Calendar__MobilePopup');

        currentSelectedEvent = 0;
    }

    export const ToggleCalMode = function(calview) {
        calendarViewToggleButtons.forEach((calbtn) => {
            if (calbtn !== null) {
                if (calbtn.dataset.calview == calview) {
                    calbtn.dataset.active = 'true';
                } else {
                    calbtn.dataset.active = 'false';
                }
            }
        });

        calendarViewToggleSwitch.forEach((toggle) => {
            if (toggle !== null) {
                toggle.dataset.calview = calview;
            }
        });

        calendarViews.forEach((vw) => {
            if (vw !== null) {
                if (vw.dataset.calview == calview) {
                    vw.dataset.open = 'true';
                } else {
                    vw.dataset.open = 'false';
                }
            }
        });

        calendarDefaultView = calview;

        sessionStorage.setItem("calview", calview);
    }

    export const calculatePopupPosition = function(btn) {
        const outerBounds = calendarMonth.getBoundingClientRect();
        const pop = calendarPopup.getBoundingClientRect();
        const btnprops = btn.getBoundingClientRect();

        const popupContent = calendarPopup.querySelector('.Calendar__Popup--content');
        const popCprops = popupContent.getBoundingClientRect();
        const popupPointer = calendarPopup.querySelector('.Calendar__Popup--pointer');
        const popPprops = popupPointer.getBoundingClientRect();


        let btnTop = btnprops.top;
        let btnLeft = btnprops.left;

        popupPointer.style.left = '-19px';
        popupPointer.style.top = '0';

        let leftPosition = (btnprops.left - outerBounds.left) + btnprops.width + popPprops.width;
        calendarPopup.classList.remove('-invert');
        if ((leftPosition + pop.width + popPprops.width) > outerBounds.width) {
            leftPosition = (btnprops.left - outerBounds.left) - pop.width - popPprops.width;
            calendarPopup.classList.add('-invert');
            popupPointer.style.left = '100%';
        }

        let topPosition = btnTop - outerBounds.top - 100;
        popupPointer.style.top = '100px';

        if ((topPosition + pop.height) > outerBounds.height + (pop.height - popCprops.height)) {
            topPosition = outerBounds.height - pop.height + (pop.height - popCprops.height);
            popupPointer.style.top = (btnTop - outerBounds.top) - topPosition + (btnprops.height / 2) - (popPprops.height / 2) + 'px';
        }

        calendarPopup.style.top = topPosition + 'px';
        calendarPopup.style.left = leftPosition + 'px';
    }

    export const setPopupContents = function(btn) {
        let evtid = btn.dataset.id;

        pCategory.forEach((category) => category.innerHTML = btn.dataset.evttype);
        pTitle.forEach((title) => title.innerHTML = btn.dataset.title);
        pDate.forEach((date) => date.innerHTML = btn.dataset.date);
        pTime.forEach((time) => time.innerHTML = btn.dataset.time);

        pLocation.forEach((location) => location.innerHTML = btn.dataset.location);
        
        pDesc.forEach((desc) => desc.innerHTML = btn.dataset.desc);
        
        pLink.forEach((link) => link.setAttribute('href', btn.dataset.evtlinkurl));
        pLink.forEach((link) => link.innerHTML = btn.dataset.evtlinktext);
        pMobileButton.forEach((button) => button.setAttribute('href', btn.dataset.evtlinkurl));
        pMobileButton.forEach((button) => button.innerHTML = btn.dataset.evtlinktext);

        pMobile.dataset.open = true;
    }

    export const togglePopup = function(btn) {
        let selectedDay = document.querySelector('.Calendar__DayCell.-selected');
        if (selectedDay != null) {
            selectedDay.classList.remove('-selected');
        }

        let selectedEvt = document.querySelector('.btn-pop[data-open="true"]');
        if (selectedEvt != null) {
            selectedEvt.dataset.open = false;
        }

        if (btn == null) {
            calendarPopup.classList.remove('-active');
            pMobile.classList.remove('-active');
        }
        else
        {
            setPopupContents(btn);
            calculatePopupPosition(btn);
            
            if (currentSelectedEvent == btn.dataset.id) {
                if (calendarPopup.classList.contains('-active')) {
                    calendarPopup.classList.remove('-active');
                }
                else {
                    calendarPopup.classList.add('-active');
                    btn.closest('.Calendar__DayCell')?.classList.add('-selected');
                    btn.dataset.open = true;
                }
                if (pMobile.classList.contains('-active')) {
                    pMobile.classList.remove('-active');
                }
                else {
                    pMobile.classList.add('-active');
                    btn.closest('.Calendar__DayCell')?.classList.add('-selected');
                    btn.dataset.open = true;
                }
            } else {
                calendarPopup.classList.add('-active');
                pMobile.classList.add('-active');
                currentSelectedEvent = btn.dataset.id;
                btn.closest('.Calendar__DayCell')?.classList.add('-selected');
                btn.dataset.open = true;
            }
        }
    }

    export const setContainerHeight = function() {
        let categoriesBounds =  calendarCategories.getBoundingClientRect();
        let calendarBounds = calendarMonth.getBoundingClientRect();

        calendarMainContainer.style.minHeight = categoriesBounds.height + calendarBounds.height + 'px';
        calendarPopup.classList.remove('-active');

        calendarSelector.forEach((sel) => sel.classList.remove('-inactive'));
    }

    export const ConfigureButtons = () => {
        calendarViewToggleButtons.forEach((calbtn) => {
            calbtn.addEventListener('click', () => {
                if (calbtn.dataset.active != 'true') {
                    ToggleCalMode(calbtn.dataset.calview);
                    calendarPopup.classList.remove('-active');
                }
            })
        });
    
        calendarEventBtns.forEach((evtbtn) => {
            evtbtn.addEventListener('click', (evt) => {
                evt.stopPropagation();
                calendarMonthDropdown.classList.remove('-active');
                togglePopup(evtbtn);
            });
        });
    
        calendarMonthSelector.addEventListener('click', () => {
            if (calendarMonthDropdown.classList.contains('-active')) {
                calendarMonthDropdown.classList.remove('-active');
            } else {
                calendarMonthDropdown.classList.add('-active');
            }
        });

        document.addEventListener('click', event => {
            const isClickInPopup = calendarPopup.contains(event.target);
            const isClickMonthSelector = calendarMonthSelector.contains(event.target);
    
            if (!isClickInPopup) {
                togglePopup();
            }
    
            if (!isClickMonthSelector) {
                calendarMonthDropdown.classList.remove('-active');
            }
        });
    }

    export const OnContentLoaded = () => {
        if (calendarMainContainer) {
            ConfigureButtons();
    
            calendarSelector.forEach((sel) => sel.classList.remove('-inactive'));
            
            // Use page default, if provided
            let providedCalview = calendarDefaultView;
            if (providedCalview != '' && providedCalview != null) {
                ToggleCalMode(providedCalview);
            }
            else {
                // Fall back to session storage otherwise
                let storedCalview = sessionStorage.getItem("calview");
                if (storedCalview != '' && storedCalview != null) {
                    ToggleCalMode(storedCalview)
                } else {
                    ToggleCalMode('calendar');
                }
            }
    
            setTimeout(() => {
                setContainerHeight();
            }, 1000);
        }
    }

    document.addEventListener("DOMContentLoaded", OnContentLoaded);

    window.onresize = setContainerHeight;